import React from 'react';
import {Button} from 'antd';

const Page_404 = () => {
	return (
		<div className="flex flex-col justify-center h-screen items-center">
			<p className='font-museoSansBold text-9xl text-gray mb-[-60px]'>
					Error
			</p>
			<p className='font-museoSansBold text-9xl text-primaryBlue'>
					404
			</p>
			<p className='font-museoSansBold text-5xl text-primaryBlue mb-5'>
				Sorry! This page doesn't exist!
			</p>
			<Button type='primary' href={window.location.origin}>Go to Home</Button>
		</div>
	)
}

export default Page_404;